export default "__VITE_ASSET__PrLfo_qv__"